// components/CallToAction.jsx
import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import './CallToAction.css';
import callImage from '../assets/callus.jpg';

const CallToAction = ({ 
  title,                    // Titre du bloc
  button1Text = null,       // Texte du premier bouton (optionnel)
  button2Text = null,       // Texte du deuxième bouton (optionnel)
  onButton1Click = null,    // Action du premier bouton
  onButton2Click = null,    // Action du deuxième bouton
  showButton1 = true,       // Afficher/cacher bouton 1
  showButton2 = true,       // Afficher/cacher bouton 2
  button1Icon = null,       // Icône du bouton 1 (ex: <FaWhatsapp />)
  variant = "primary"       // Style du bloc
}) => {

  // Déterminer si on a un seul bouton (peu importe lequel est utilisé)
  const hasSingleButton = ( 
    (showButton1 && button1Text && (!showButton2 || !button2Text)) ||
    (showButton2 && button2Text && (!showButton1 || !button1Text))
  );
  
  return (
    <div className="next-level-section" 
        style={{
            backgroundImage: `url(${callImage.src || callImage})`,
        }}
    >
      <div className="next-level-overlay"></div>
      
      {title && <h3 className="next-level-title">{title}</h3>}
      
      <div className={`next-level-buttons ${hasSingleButton ? 'single-button' : ''}`}>
        {showButton1 && button1Text && (
          <button className="eligibility-btn" onClick={onButton1Click}>
            {button1Icon && <span className="btn-icon">{button1Icon}</span>}
            {button1Text}
          </button>
        )}
        
        {showButton2 && button2Text && (
          <button className="join-btn" onClick={onButton2Click}>
            <span className="join-text-desktop">{button2Text}</span>
            <span className="join-text-mobile">{button2Text}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default CallToAction;